import { BrowserRouter } from "react-router-dom";
import "antd/dist/antd.css"; // or 'antd/dist/antd.less'
import "./App.scss";
import Routes from "./Routes";
import { createBrowserHistory } from "history";

function App() {
  const history = createBrowserHistory();

  return (
    <BrowserRouter history={history}>
      <Routes />
    </BrowserRouter>
  );
}

export default App;
